import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const insightsPortalDeliveryDashboardAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.Analytics,
    featureToggles: [FeatureToggle.InsightsPortalDeliveryDashboard],
  },
  {
    permissions: Permission.PickupAnalytics,
    featureToggles: [FeatureToggle.InsightsPortalDeliveryDashboard],
  },
]
